import { Tag } from "components/designV2/tag/tag";
import { TooltipHover } from "components/designV2/tooltip/tooltip";
import { CustomIcon } from "components/icon/customIcon.component";
import { useTranslation } from "react-i18next";
import {
  AvatarCircle,
  AvatarImage,
  CloseButton,
  HeaderRow,
  MetaRow,
  MetaTooltipContent,
  Name,
  NameBlock,
  WorkerHeader,
} from "./profilePanel.styled";

interface ProfilePanelHeaderProps {
  avatarUrl: string | null | undefined;
  fullName: string;
  primaryTeamLabel: string | null;
  primaryRoleLabel: string | null;
  additionalTagCount: number;
  teamLabels: string[];
  onClose: () => void;
}

/**
 * Handles profile panel header.
 */
export const ProfilePanelHeader = (
  props: ProfilePanelHeaderProps,
): JSX.Element => {
  const { t } = useTranslation();

  return (
    <HeaderRow>
      <WorkerHeader>
        <AvatarCircle>
          {props.avatarUrl ? (
            <AvatarImage src={props.avatarUrl} alt={props.fullName} />
          ) : (
            <CustomIcon name="v2/person" size="22px" />
          )}
        </AvatarCircle>
        <NameBlock>
          <Name>{props.fullName}</Name>
          <MetaRow>
            {props.primaryTeamLabel && <Tag text={props.primaryTeamLabel} />}
            {props.primaryRoleLabel && <Tag text={props.primaryRoleLabel} />}
            {props.additionalTagCount > 0 && (
              <TooltipHover
                content={
                  <MetaTooltipContent>
                    {props.teamLabels.length > 0
                      ? props.teamLabels.join(", ")
                      : "-"}
                  </MetaTooltipContent>
                }
                arrow="down"
              >
                <Tag text={`+${props.additionalTagCount}`} />
              </TooltipHover>
            )}
          </MetaRow>
        </NameBlock>
      </WorkerHeader>
      <CloseButton
        iconName="v2/cross"
        size="small"
        aria-label={t("DesignComponents.CloseModal")}
        onClick={props.onClose}
      />
    </HeaderRow>
  );
};
